import React, { useState } from 'react';
import { LinkOutlined, PlayCircleFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { feedVideoEmbed, feedVideoThumbnail } from '../../shared/utils/feed-post';

const PROVIDERS: Record<string, string> = {
  youtube: 'YouTube',
  vimeo: 'Vimeo',
  instagram: 'Instagram',
  tiktok: 'TikTok',
};

/**
 * Gönderideki bağlantı. YouTube/Vimeo oynatıcısı yalnız tıklanınca yüklenir (çerez ve sayfa hızı);
 * diğer bağlantılar alan adı + başlıkla, yeni sekmede ve `nofollow ugc` ile açılır.
 */
export default function FeedPostLink({ link }: { link: LeagueFeed.Link }) {
  const { t } = useTranslation('leagues');
  const [playing, setPlaying] = useState(false);
  const embed = feedVideoEmbed(link);
  const thumbnail = feedVideoThumbnail(link);
  const provider = link.saglayici ? PROVIDERS[link.saglayici] : null;
  const title =
    link.baslik ||
    (provider ? t('detail.posts.videoOn', { provider }) : link.url.replace(/^https:\/\/(www\.)?/, ''));

  if (embed && playing) {
    return (
      <div className="feed-post-link feed-post-link--player">
        <iframe
          src={embed}
          title={title}
          allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        />
      </div>
    );
  }
  if (embed) {
    return (
      <button
        type="button"
        className="feed-post-link feed-post-link--video"
        onClick={() => setPlaying(true)}
        aria-label={t('detail.posts.play', { title })}
      >
        <span className="feed-post-link__poster">
          {thumbnail && <img src={thumbnail} alt="" width={480} height={360} loading="lazy" decoding="async" />}
          <PlayCircleFilled aria-hidden="true" />
        </span>
        <span className="feed-post-link__caption">
          <strong>{title}</strong>
          <span>{t('detail.posts.playHint', { provider })}</span>
        </span>
      </button>
    );
  }
  return (
    <a
      className="feed-post-link feed-post-link--card"
      href={link.url}
      target="_blank"
      rel="nofollow ugc noopener noreferrer"
    >
      {provider ? <PlayCircleFilled aria-hidden="true" /> : <LinkOutlined aria-hidden="true" />}
      <span className="feed-post-link__caption">
        <strong>{title}</strong>
        <span>{link.alan}</span>
      </span>
    </a>
  );
}
